import { apiClient } from "./client";

// HR Center announcements + the splash screen. ⚠️ Return `res.data`.
export async function fetchAnnouncements() {
  return (await apiClient("get", "/hr/announcements")).data;
}

export async function createAnnouncement(title, body, userIds) {
  return (await apiClient("post", "/hr/announcements", { title, body, user_ids: userIds })).data;
}

export async function fetchMyPendingAnnouncements() {
  return (await apiClient("get", "/me/announcements")).data;
}

export async function fetchMyAnnouncement(id) {
  return (await apiClient("get", `/me/announcements/${id}`)).data;
}

export async function acknowledgeAnnouncement(id) {
  return (await apiClient("post", `/me/announcements/${id}/acknowledge`)).data;
}
